module.exports = __webpack_public_path__ + "img/logic_hi.fd3b61c8.jpg";